<script lang="ts">
    import { operationSources } from "../../../config"
    import { _ } from "svelte-i18n"

    let opSourceCodes = Object.keys(operationSources)
        .map(Number)
        .sort((a, b) => a - b)
</script>

<div class="legends">
    <div class="legend">
        <div class="headline">{$_("cart.legend.legend")}</div>
        <div class="items">
            <section>
                {#each opSourceCodes as code}
                    <div class="item">
                        <div class="icon">
                            <img src="{operationSources[code].img}" alt="{operationSources[code].label}" width="24" />
                        </div>
                        <div class="text">{operationSources[code].label}</div>
                    </div>
                {/each}
            </section>
            <section>
                <div class="item">
                    <div class="icon"><span class="state grey"></span></div>
                    <div class="text">{$_("cart.legend.operationCreated")}</div>
                </div>
                <div class="item">
                    <div class="icon">
                        <span class="state yellow"></span>
                    </div>
                    <div class="text">{$_("cart.legend.inProgress")}</div>
                </div>
                <div class="item">
                    <div class="icon">
                        <span class="state green"></span>
                    </div>
                    <div class="text">{$_("cart.legend.offerCreated")}</div>
                </div>
            </section>
            <section>
                <div class="item">
                    <div class="icon">*</div>
                    <div class="text">{$_("cart.legend.mandatoryField")}</div>
                </div>
            </section>
        </div>
    </div>
</div>
